/**
 * @generated SignedSource<<46bdbecbbafe3488a48ad5c5fc179a8d>>
 * @relayHash 3b50b3b5eda523717d7fd0d886668224
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

// @relayRequestID 3b50b3b5eda523717d7fd0d886668224

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "emails"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "emails",
        "variableName": "emails"
      }
    ],
    "concreteType": "BasicResponse",
    "kind": "LinkedField",
    "name": "updateUsersToIgnore",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "ok",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UpdateUsersToIgnoreMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UpdateUsersToIgnoreMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "3b50b3b5eda523717d7fd0d886668224",
    "metadata": {},
    "name": "UpdateUsersToIgnoreMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

node.hash = "72d8312b84d0b6b472aa15406e2cd963";

export default node;
